import { render, staticRenderFns } from "./JcomMenuPermissionList.vue?vue&type=template&id=ec5d067e"
import script from "./JcomMenuPermissionList.vue?vue&type=script&lang=js"
export * from "./JcomMenuPermissionList.vue?vue&type=script&lang=js"
import style0 from "./JcomMenuPermissionList.vue?vue&type=style&index=0&id=ec5d067e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports